import Vue from "vue";
import VueConfirmDialog from "vue-confirm-dialog";
import VModal from "vue-js-modal";
import StackModal from "@innologica/vue-stackable-modal";

import App from "./App.vue";

import vuetify from "./plugins/vuetify";
import Vuetify from "vuetify";
// import "vuetify/dist/vuetify.min.css";
// import "@mdi/font/scss/materialdesignicons.scss";

import axios from "axios";
import "./assets/css/MyStyle.css";
import { getInfo } from "./js/common_function";
import config from "./config/config";
import { router } from "./router/index";
import store from "./store/store";

// Import Bootstrap an BootstrapVue CSS files (order is important)

import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
// import 'bootstrap/scss/bootstrap.scss'
// import 'bootstrap-icons/font/bootstrap-icons.css'
// import 'x-editable/dist/bootstrap3-editable/css/bootstrap-editable.css'
import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
import "./plugins/fontAwesomeIcon.js";
import VueGeolocationApi from "vue-geolocation-api";
import * as VueGoogleMaps from "vue2-google-maps";

import VueMoment from "vue-moment";
import moment from "moment";
import VueLuxon from "vue-luxon";
import printJS from "print-js"; // Import package
import Meta from "vue-meta";

Vue.use(VModal, { dialog: true, dynamic: true });
Vue.use(StackModal);

Vue.use(VueGeolocationApi, {
  enableHighAccuracy: false, // 대략적인 값이라도 상관 없음: 기본값
  //
  //     // 위치 정보가 충분히 캐시되었으면, 이 프로퍼티를 설정하자,
  //     // 위치 정보를 강제로 재확인하기 위해 사용하기도 하는 이 값의 기본 값은 0이다.
  maximumAge: 30000, // 5분이 지나기 전까지는 수정되지 않아도 됨
  //
  //     // 위치 정보를 받기 위해 얼마나 오랫동안 대기할 것인가?
  //     // 기본값은 Infinity이므로 getCurrentPosition()은 무한정 대기한다.
  timeout: 15000, // 15초 이상 기다리지 않는다.
});

Vue.config.productionTip = false;
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBM1k_LY4U8w2BHYvsAL6JewDasQzIqNtk",
    libraries: "places",
    region: "KR",
  },
});

export const eventBus = new Vue();

Vue.component("vue-confirm-dialog", VueConfirmDialog.default);
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$getInfo = getInfo;
Vue.prototype.$config = config;

Vue.use(Vuetify);
Vue.use(VueConfirmDialog);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(PaperDashboard);
Vue.use(VueLuxon);
Vue.use(Meta);

Vue.use(VueMoment, {
  moment,
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
